import { CommercialLocationBookingCreate } from './CommercialLocationBookingCreate'

export const commercial_location_booking = {
  create: CommercialLocationBookingCreate,
}
